import React, {Component} from 'react'
import {string, number, func, arrayOf, shape} from 'prop-types'
import Img from 'gatsby-image'
import Gallery from 'react-photo-gallery'
import Lightbox from 'react-images'

class ImageGallery extends Component {
  static propTypes = {
    photos: arrayOf(
      shape({
        src: string.isRequired,
        alt: string,
        key: string,
        width: number.isRequired,
        height: number.isRequired,
      })
    ).isRequired,
    columns: number,
    margin: number,
    onClick: func,
    ImageComponent: func,
  }

  state = {
    currentImage: 0,
    lightboxIsOpen: false,
  }

  _handleOpen = image => {
    this.setState({
      currentImage: image.index,
      lightboxIsOpen: true,
    })
  }

  _handleClose = () => {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    })
  }

  _handlePrev = () => {
    this.setState({
      currentImage: this.state.currentImage - 1,
    })
  }

  _handleNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1,
    })
  }

  render() {
    return (
      <div>
        <Gallery photos={this.props.photos} onClick={(_, image) => this._handleOpen(image)} />
        <Lightbox
          images={this.props.photos}
          onClose={this._handleClose}
          onClickPrev={this._handlePrev}
          onClickNext={this._handleNext}
          currentImage={this.state.currentImage}
          isOpen={this.state.lightboxIsOpen}
          showCloseButton={false}
          showImageCount={false}
          backdropClosesModal={true}
        />
      </div>
    )
  }
}
export default ImageGallery
